export function plans() {
    $(window).on("load resize", function () {
        let $plans = $('.plans');
        let premiumNotice = $plans.find('.premium .notice');

        if (window.innerWidth >= 1024) {
            if (premiumNotice.length) {
                $plans.find('.plan:not(.premium)').each(function () {
                    let $this = $(this);
                    let height = $this.outerHeight() - premiumNotice.outerHeight(true);
                    $this.css('height', height + 'px');
                });
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/plans.js